import { titleUI } from 'platform/forms-system/src/js/web-component-patterns';
import {
  GrossIncomeDescription,
  OtherIncomeDescription,
} from '../../../../components/FormDescriptions';
import {
  buildGroupedCurrencySchemaProperties,
  buildGroupedCurrencyUIProperties,
} from '../../../../definitions';
import content from '../../../../locales/en/content.json';
import { strWithYear } from '../../../../utils/helpers';

const TITLE_TEXT = strWithYear(content['household-info--spouse-income-title']);

const SCHEMA_CONFIG = [
  {
    dataField: 'spouseGrossIncome',
    subtitle: content['household-info--spouse-income-gross-title'],
    description: GrossIncomeDescription,
    label: strWithYear(content['household-info--spouse-income-gross-label']),
  },
  {
    dataField: 'spouseNetIncome',
    subtitle: content['household-info--spouse-income-net-title'],
    description: content['household-info--spouse-income-net-description'],
    label: strWithYear(content['household-info--spouse-income-net-label']),
  },
  {
    dataField: 'spouseOtherIncome',
    subtitle: content['household-info--spouse-income-other-title'],
    description: OtherIncomeDescription,
    label: strWithYear(content['household-info--spouse-income-other-label']),
  },
];

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    ...buildGroupedCurrencyUIProperties(SCHEMA_CONFIG),
  },
  schema: {
    type: 'object',
    required: [
      'view:spouseGrossIncome',
      'view:spouseNetIncome',
      'view:spouseOtherIncome',
    ],
    properties: buildGroupedCurrencySchemaProperties(SCHEMA_CONFIG),
  },
};
